import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose, setPropTypes, defaultProps } from 'recompose'

import { Main } from './styled'

const StdForm = (props) => {
  const { title, children, accessoriesHeader } = props

  return (
    <Main>
      <div className='header'>
        {title}
        {accessoriesHeader?<div>{accessoriesHeader}</div>:null}
      </div>
      <div className='content'>
        {children}
      </div>
    </Main>
  )
}

const propTypes = {
  title: PropTypes.string
}

const defaultProp = {
  title: 'Title'
}

export default compose(
  setPropTypes(propTypes),
  defaultProps(defaultProp),
  connect((state, props) => ({
    children: props.children
  })),
)(StdForm)